// Dynamically generate the navigation based on the widgets placed on the page.
const $ = require('jquery');

const $navItems = $('.volt .js-sticky-nav nav ul');
const $pageSections = $('.volt div[data-navigation]');

$pageSections.each((i, v) => {
  const navigationText = $(v).data('navigation');

  if (navigationText !== undefined && navigationText !== '') {
    $navItems.append(`<li><a href="#${$(v).attr('id')}">${$(v).data('navigation')}</a></li>`);
    const $whatsNew = $(v).find('.js-tabs-status');
    if ($whatsNew.length > 0) {
      $navItems.append(`<li><a href="#${$(v).attr('id')}">${$whatsNew.val()}</a></li>`);
    }
  }
});
const $menuItems = $navItems.find('li a');
$menuItems.click((e) => {
  e.preventDefault();
  const $selectedElement = $(e.currentTarget);
  const scrollToId = $selectedElement.attr('href').substring(1);
  const scrollToDiv = $(`#${scrollToId}`);
  $('html, body').animate({
    scrollTop: scrollToDiv.offset().top,
  }, 2000);
});
